import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import TechnicalUploadsForm from '@rd-web-markets/shared/dist/claim_group/technical_uploads/TechnicalUploadsForm';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import fundingDocumentService from '../../../../services/elster/funding_documents.service';
const FundingDocument = _ref => {
  var _funding$document2;
  let {
    funding,
    setFundings,
    setParentHasUnsavedChanges,
    isLoading: parentLoading
  } = _ref;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const {
    createFundingDocument,
    deleteFundingDocument
  } = fundingDocumentService.useCrud(setLoading, setFundings);
  const submitForm = useCallback(async (_, file) => {
    await createFundingDocument({
      fundingId: funding.id,
      formDataJson: {
        document: file
      }
    });
    if (setParentHasUnsavedChanges) {
      setParentHasUnsavedChanges(false);
    }
  }, [funding, createFundingDocument, setParentHasUnsavedChanges]);
  const deleteFileHandler = useErrorHandling(useCallback(async () => {
    var _funding$document;
    const warningMessage = t('are_you_sure_you_want_to_delete_the_file') + ": ".concat((_funding$document = funding.document) === null || _funding$document === void 0 ? void 0 : _funding$document.filename, "?");
    if (window.confirm(warningMessage)) {
      await deleteFundingDocument({
        fundingId: funding.id
      });
      if (setParentHasUnsavedChanges) {
        setParentHasUnsavedChanges(false);
      }
    }
  }, [t, deleteFundingDocument, funding.id, (_funding$document2 = funding.document) === null || _funding$document2 === void 0 ? void 0 : _funding$document2.filename, setParentHasUnsavedChanges]));
  const isLoading = loading || parentLoading;
  if (funding.document) {
    var _funding$document3, _funding$document4;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      rel: "noreferrer",
      href: (_funding$document3 = funding.document) === null || _funding$document3 === void 0 ? void 0 : _funding$document3.url,
      target: "_blank",
      className: "me-2"
    }, /*#__PURE__*/React.createElement("small", null, (_funding$document4 = funding.document) === null || _funding$document4 === void 0 ? void 0 : _funding$document4.filename)), /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: deleteFileHandler,
      disabled: isLoading,
      size: "sm"
    }));
  }
  return /*#__PURE__*/React.createElement(TechnicalUploadsForm, {
    isImmutableUnderReview: false,
    handleSubmit: submitForm,
    loading: isLoading,
    showDocumentType: false,
    showAddCommentTextInput: false,
    setParentHasUnsavedChanges: setParentHasUnsavedChanges,
    addDocumentClass: {
      marginRight: '60px'
    }
  });
};
export default FundingDocument;